import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MeusVeiculosCreatePage } from './meus-veiculos-create.page';

const routes: Routes = [
  {
    path: '',
    component: MeusVeiculosCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeusVeiculosCreatePageRoutingModule {}
